import { WGS_ABOUT } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './WgsAbout'

export default withLocalization(Component, WGS_ABOUT)
